// Engine strengths for playing out a position (see PlayOutBoard). `skill` is Stockfish's 0–20 Skill
// Level (deliberately worse moves some of the time) and `depth` shortens the search, so low levels
// lose material like a human rather than just play slower. Ratings are approximate and labelled so.

export type PlayLevel = {
  key: string;
  label: string;
  // Roughly the strength it plays at, for the picker's subtitle.
  about: string;
  skill: number;
  depth: number;
};

export const PLAY_LEVELS: PlayLevel[] = [
  { key: 'beginner', label: 'Beginner', about: 'around 800', skill: 0, depth: 1 },
  { key: 'casual', label: 'Casual', about: 'around 1100', skill: 3, depth: 3 },
  { key: 'intermediate', label: 'Intermediate', about: 'around 1500', skill: 7, depth: 6 },
  { key: 'advanced', label: 'Advanced', about: 'around 1800', skill: 12, depth: 9 },
  { key: 'expert', label: 'Expert', about: 'around 2200', skill: 17, depth: 12 },
];

// Default level, mid-table: a level you beat effortlessly can't tell you whether you held the
// position.
export const DEFAULT_PLAY_LEVEL = 'intermediate';

// The last level picked, per browser. Only the key is stored; an unknown one falls back.
const STORAGE_KEY = 'sc-play-level';

export function levelByKey(key: string | null | undefined): PlayLevel {
  return PLAY_LEVELS.find((l) => l.key === key) ?? PLAY_LEVELS.find((l) => l.key === DEFAULT_PLAY_LEVEL)!;
}

export function loadPlayLevel(): PlayLevel {
  try {
    return levelByKey(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return levelByKey(DEFAULT_PLAY_LEVEL);
  }
}

export function savePlayLevel(key: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, key);
  } catch {
    /* private mode / storage disabled — the level just won't persist */
  }
}
